import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { makeStyles } from '@material-ui/core';
import LogoFull from '../../components/Root/LogoFull';
import LogoIcon from '../../components/Root/LogoIcon';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  useSidebarOpenState,
  Link,
  SidebarScrollWrapper,
  GroupIcon,
  SidebarSpace,
  SidebarSubmenu,
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { ccoeAdminReadPermission } from '@internal/plugin-permission-common';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const useLogoStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 45,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();
  const { svg } = useLogoStyles();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull svg={svg} /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Exclude from nav.rest()
      nav.take('page:catalog-graph');
      nav.take('page:kubernetes');
      nav.take('page:catalog-import');

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            {nav.take('page:search')}
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:home')}
            {nav.take('page:catalog')}
            {nav.take('page:github-marketplace')}
            <MyGroupsSidebarItem
              singularTitle="My Group"
              pluralTitle="My Groups"
              icon={GroupIcon}
            />
            {nav.take('page:api-docs')}
            {nav.take('page:techdocs')}
            {nav.take('page:scaffolder')}
            {nav.take('page:soundcheck')}

            <SidebarDivider />
            <SidebarScrollWrapper>{nav.rest()}</SidebarScrollWrapper>
            <SidebarSpace />
            <SidebarGroup>
              <RequirePermission
                permission={ccoeAdminReadPermission}
                errorPage={<></>}
              >
                <SidebarItem icon={SupervisorAccountIcon} text="Admin">
                  <SidebarSubmenu title="Admin">
                    {nav.take('page:app-visualizer')}
                    {nav.take('page:rbac')}
                    {nav.take('page:backstage-insights')}
                    {nav.take('page:devtools')}
                  </SidebarSubmenu>
                </SidebarItem>
              </RequirePermission>
              {nav.take('page:notifications')}
              {nav.take('page:announcements')}
            </SidebarGroup>
          </SidebarGroup>
          <SidebarDivider />
          {nav.take('page:user-settings')}
        </Sidebar>
      );
    },
  },
});
